const colors = {
    mainColor: '#2e82fe',
    secondColor: '#101116',
    transparentSecColor: '#272b36ab',
    navColor: '#10172a',
    navColorHover: '#20304e61',
    overlayColor: '#10172af2',
    whiteColor: '#FFF',
    whityBorder: '#7e7e7e',
    btnColor1: '#2e82fe',
    blackColor: '#2b1266',
    experienceColor: "#1a243fc7"
}

export default colors


/*
'#111827'
'#cdb78e'
'#1a1e2cba'

*/